import enMsg from './locales/en_US.json';
import arMsg from './locales/ar_EG.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const LANG_KEY = 'i18nextLng';

const resources = {
  en: {
    translation: enMsg,
  },
  ar: {
    translation: arMsg,
  },
};

const detectorOptions = {
  order: [
    'querystring',
    'cookie',
    'localStorage',
    'localStorage',
    'navigator',
    'htmlTag',
    'path',
    'subdomain',
  ],
  lookupQuerystring: 'lng',
  lookupCookie: LANG_KEY,
  lookupLocalStorage: LANG_KEY,
  lookuplocalStorage: LANG_KEY,
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,
  caches: ['localStorage', 'cookie'],
  htmlTag: document.documentElement,
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: detectorOptions,
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
